export default "__VITE_ASSET__9F2mUxSx__"